import { gsap } from "gsap";

/**
 *
 * @param {HTMLElement | null} container
 */
export function appAnimateChangingText(container) {
  if (container !== null) {
    const items = container.querySelectorAll("li");
    const wordHeight = container.clientHeight / items.length;
    const containerParent = container.parentElement;

    /* initial */
    gsap.set(containerParent, {
      height: wordHeight,
      overflow: "hidden",
    });

    gsap.set(container, {
      width: items[0].children[0].clientWidth,
    });

    /* timeline */
    const timeline = gsap.timeline({
      repeat: -1,
      defaults: {
        ease: "power4",
      },
    });

    gsap.utils.toArray(items).forEach((el, index) => {
      timeline.to(container, {
        width: el.children[0].clientWidth,
        y: index * wordHeight * -1,
        duration: 1,
      });
    });

    timeline.to(container, {
      width: items[0].children[0].clientWidth,
      duration: 1,
      y: 0,
    });
  }
}
